<template>
  <div class="MainStepsForm">
    <div class="container" v-show="tabIdx == 'tab1'">
      <a-alert
        message="中国知链为你自行上传的作品进行版权存证，不对您上传内容的真实性进行验证"
        type="warning"
        show-icon
      />

      <steps :stepIdx="3"></steps>

      <div class="commonWhiteBg">
        <div class="ant-popover-arrow"></div>
        <div class="commonTitle">版权监测</div>
        <div class="formWrap">
          <el-form ref="form" :model="form" :rules="rules" label-width="140px">
            <el-form-item label="选择存证文件" prop="evidenceFile">
              <el-select
                v-model="form.evidenceFile"
                multiple
                clearable
                placeholder="请选择已存证名称"
                @change="chooseFile"
              >
               <el-option
                  v-for="(item, index) in fileList"
                  :key="index"
                  :label="item.sourceName"
                  :value="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设定监测名称" prop="subject">
              <el-input v-model="form.subject"></el-input>
            </el-form-item>
            <el-form-item label="监测关键词" prop="keyWords">
              <el-input v-model="form.keyWords"></el-input>
            </el-form-item>

            <el-form-item label="设定监测时间" prop="time">
              <el-date-picker
                v-model="form.time"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="选择监测范围" prop="platform">
              <el-checkbox-group v-model="form.platform">
                <el-checkbox
                  v-for="(item, index) in constants.platform"
                  :key="index"
                  :label="item.value"
                >
                  {{ item.label }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item
              label="支付方式"
              prop="paymode"
              class="choosePayStyle"
            >
              <el-radio-group v-model="form.paymode">
                <el-radio label="vip">
                  <span class="onlyText"
                    >中国知链会员权益支付（当前存证次数可用{{vipInfo?vipInfo.detectCount:0}}次）</span
                  >
                </el-radio>
                <el-radio label="alipay">
                  <i class="iconfont aliPayColor"> &#xe634; </i>
                  <span>支付宝支付</span></el-radio
                >
                <!-- <el-radio label="wechat">
                  <i class="iconfont weChatColor"> &#xe633; </i>
                  <span>微信支付</span></el-radio
                > -->
              </el-radio-group>
              <router-link class="buyVip" :to="{ path: '/Vip' }"
                >购买会员</router-link
              >
            </el-form-item>
            <el-form-item label="支付金额" v-if="form.paymode != 'vip'">
              <div><em class="bigPrice"> {{form.orderAmount}} </em> 元</div>
            </el-form-item>
            <el-form-item class="submitRow">
              <el-button type="primary" @click="onSubmit"
                >提交版权登记</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <result-view v-if="tabIdx == 'tab2'" :form="form" @set-tab-idx="setTabIdx">
    </result-view>
  </div>
</template>

<script>
import { queryExistOrderItems } from "@/api/EvidenceService";
import constants from "@/utils/constants";
import Steps from "../../components/Steps";
import multipleSelect from "../../../../components/form/multipleSelect";
import choosePersonDialog from "../../../../components/form/choosePersonDialog";
import resultView from "./components/resultView";
import { mapGetters } from "vuex";
import { mixinsScrollErrorPosition } from '../../../../mixins'
export default {
  name: "MonitorInputForm",
    mixins: [mixinsScrollErrorPosition],
  components: { Steps, multipleSelect, choosePersonDialog, resultView },
  computed: {
    ...mapGetters(["mid", "userInfo", "evidencePaymentPrice","vipInfo"]),
  },
  data() {
    return {
      constants,
      fileList: [],
      tabIdx: "tab1",
      worksFileOpt: [
        {
          value: "1",
          label: "存证作品名称1",
        },
        {
          value: "2",
          label: "存证作品名称2",
        },
        {
          value: "3",
          label: "存证作品名称3",
        },
        {
          value: "4",
          label: "备选项4",
        },
        {
          value: "5",
          label: "备选项5",
        },
      ],
      platformOpt: [
        {
          value: "1",
          label: "XXX平台1",
        },
        {
          value: "2",
          label: "XXX平台2",
        },
        {
          value: "3",
          label: "XXX平台3",
        },
      ],
      form: {
        orderAmount: 0,
        evidenceFile: [],
        subject: "",
        keyWords: "",
        time: "",
        platform: [],
        paymode: 'wechat',
      },
       rules: {
        subject: [
          { required: true, message: '请输入监测名称', trigger: 'blur' },
          { min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' }
        ],
      },
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      queryExistOrderItems().then(({ data }) => {
        this.fileList = data;
      });
    },
    calAmount() {
      let amount = 0;
      let detectConfig = this.evidencePaymentPrice.detect;
      for (let i = 0; i < this.form.files.length; i++) {
        const file = this.form.files[i];
        //
        amount += detectConfig.amount * 1;
      }

      this.form.orderAmount = amount;
    },
   async onSubmit () {
      console.log("onSubmit..")
      try {
        const formBaseResult = await this.$refs['form'].validate()
      } catch (error) {
        // 有错误,定位到错误
        // eslint-disable-next-line
        console.error(error)
        this.mixinsScrollView()
        return
      }
      this.setTabIdx('tab2')
     },
    setTabIdx(tabIdx) {
      this.tabIdx = tabIdx;
    },
    chooseFile(){
      let files=[];
      for (let i = 0; i < this.form.evidenceFile.length; i++) {
        const element = this.form.evidenceFile[i];
        files.push(this.fileList[element]);
      }
      this.form.files=files;
      this.calAmount();
    }
  },
};
</script>

<style lang='scss' scoped>
@import "../../../../assets/css/inputForm.scss";
.commonWhiteBg {
  /deep/ .ant-popover-arrow {
    left: 46%;
  }
}
</style>
